<template>
  <div class="container">
    <img class="wow-logo" src="https://wowsite.musicwow.com/mobile_musicwow/image/wow-logo.png"/>
    <p class="main-title">音乐窝</p>
    <div class="wx-open-weapp">
      <wx-open-launch-weapp
        id="launch-btn"
        appid="wxe7607ce964621c45"
        :path="$route.query.miniapp_path"
        @launch="handleLaunchFn"
        @error="handleErrorFn"
      >
        <script type="text/wxtag-template">
            <style>.btn {width: 100%; text-align: center;}</style>
            <div class="btn" style="color:#fff;">跳转小程序</div>
        </script>
      </wx-open-launch-weapp>
    </div>
    <div class="footer">
      <img src="https://wowsite.musicwow.com/mobile_musicwow/image/miniapp-logo.png"/>
      <span>小程序</span>
    </div>
  </div>
</template>
 
<script>
export default {
  data () {
    return {
    }
  },
  mounted () {},
  methods: {
    handleLaunchFn (e) {
      console.log('success', e)
    },
    handleErrorFn(e){
      console.log('fail', e.detail);
    },
  }
}
</script>
<style lang="scss" scoped>
.container{
  height: 100vh;
  overflow: hidden;
  position: relative;
  .wow-logo{
    width: 110px;
    height: auto;
    margin-top: 68px;
  }
  .main-title{
    margin-top: 25px;
    font-size: 18px;
    line-height: 18px;
    font-weight: 500;
    color: #333333;
  }
  .wx-open-weapp {
    width: 60vw;
    height: 48px;
    margin: 48px auto 0 auto;
    color: #ffffff;
    #launch-btn {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      background-color: #43af3d;
      color: #ffffff;
      border-radius: 24px;
      font-size: 20px;
    }
  }
  .footer{
    position: absolute;
    bottom: 30px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      width: 20px;
      height: auto;
      margin-right: 10px;
    }
    span{
      font-size: 16px;
      color: #333333;
      font-weight: 500;
    }
  }
}
</style>